export const commonEnv = {
  production: false,
  BaseURL: 'https://api-dev.seuingressoaqui.com/v1',
  FrontendUrl: 'https://dev.seuingressoaqui.com',
  MicroService: {
    Auth: '/auth',
    Events: '/events',
    Reports: '/reports'
  }
};
